import type { FirebaseMessagingManager } from '@app/services/FirebaseMessagingManager'

import { sink } from '@app/utils/sink'

import { createThunk } from '@app/store/thunk'

export function getFirebaseMessagingManager() {
  return createThunk(
    (_dispatch, _getState, context) => context.lookup<Promise<FirebaseMessagingManager | null>>(FirebaseMessagingManagerSymbol) ?? Promise.resolve(null)
  )
}
export function setFirebaseMessagingManager(value: Promise<FirebaseMessagingManager | null>) {
  sink(value)
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(FirebaseMessagingManagerSymbol, value))
}

const FirebaseMessagingManagerSymbol = Symbol('FirebaseMessagingManager')
